module.exports = __webpack_public_path__ + "static/img/logo-ssq.2962a532.png";